/** Wixar brand green — use Tailwind `green-500` classes where possible.
 *  This constant is for JS-only contexts (MUI sx, boxShadow, dynamic inline styles). */
export const WIXAR_GREEN = "#00c889";
export const WIXAR_GREEN_LIGHT = "#e0f5ee";

export const APK_PLATFORMS = ["MetaQuest", "OculusQuest", "PicoNeo", "Android"];
export const DESKTOP_PLATFORMS = ["Windows10", "MacOS"];

/* ── Spatial Studio ──────────────────────────────────── */
export const SPATIAL_STUDIO_PACKAGE_NAME = "com.WideWebVR.studiovrwixar";
export const SPATIAL_STUDIO_PLATFORM_IDS: Record<string, number> = {
  quest: 1,
  pico: 4,
  android: 5,
};

/* ── ADB / Device paths ────────────────────────────────── */
export const TMP_DIR = "/data/local/tmp";
export const FILE_PERMISSION = 0o644;

/** Build the device-side media cache path for a given package */
export const getMediaBasePath = (packageName: string) =>
  `/sdcard/Android/data/${packageName}/files/Medias`;

/* ── Metadata file names written alongside each media ──── */
export const MEDIA_METADATA_FILES = {
  encrypted: "encrypted.txt",
  updatedTime: "mediaUpdatedTime.txt",
  presets: "presets.txt",
} as const;

/* ── Sentinel error strings used in Redux state ────────── */
export const CANCELLED_SENTINEL = "__cancelled__";
export const VERIFICATION_FAILURE_SENTINEL = "__verification_failure__";

/* ── Polling ───────────────────────────────────────────── */
export const POLL_INTERVAL_MS = 5_000;

/* ── Desktop Agent ─────────────────────────────────────── */
export const AGENT_BASE_URL = "http://127.0.0.1:9876";
export const AGENT_WS_URL = "ws://127.0.0.1:9876/ws";
export const AGENT_POLL_INTERVAL_MS = 10_000;
export const SPATIAL_STUDIO_AGENT_ID = "spatial-studio";

/* ── MUI LinearProgress shared styling ─────────────────── */
export const PROGRESS_SX = {
  height: 6,
  borderRadius: 3,
  "& .MuiLinearProgress-bar": { backgroundColor: WIXAR_GREEN, borderRadius: 3 },
  backgroundColor: WIXAR_GREEN_LIGHT,
};
